if (!customElements.get('swiper-slider')) {
  customElements.define(
    'swiper-slider',
    class SwiperSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.checkInterval = null;
      }

      connectedCallback() {
        this.swiperContainer = this.querySelector('.swiper');
        this.jsonScript = this.querySelector('script[type="application/json"]');

        if (!this.swiperContainer || !this.jsonScript) {
          console.warn('SwiperSlider: Missing .swiper container or configuration script');
          return;
        }

        this.init();
      }

      init() {
        if (typeof Swiper !== 'undefined') {
          this.initializeSwiper();
        } else {
          let attempts = 0;
          this.checkInterval = setInterval(() => {
            attempts++;
            if (typeof Swiper !== 'undefined') {
              clearInterval(this.checkInterval);
              this.initializeSwiper();
            } else if (attempts > 10) {
              clearInterval(this.checkInterval);
              console.error('SwiperSlider: Swiper library did not load within 1 second.');
            }
          }, 100);
        }
      }

      getSwiperConfig() {
        try {
          const userConfig = JSON.parse(this.jsonScript.textContent);
          const defaults = {
            spaceBetween: 20,
            observer: true,
            observeParents: true,
            a11y: {
              prevSlideMessage: 'Previous slide',
              nextSlideMessage: 'Next slide',
            },
          };

          return { ...defaults, ...userConfig };
        } catch (e) {
          console.error('SwiperSlider: JSON parsing error', e);
          return {};
        }
      }

      initializeSwiper() {
        const config = this.getSwiperConfig();

        this.swiper = new Swiper(this.swiperContainer, config);
      }

      disconnectedCallback() {
        if (this.checkInterval) clearInterval(this.checkInterval);

        if (this.swiper) {
          this.swiper.destroy(true, true);
        }
      }
    }
  );
}
